import { render, staticRenderFns } from "./SkillDetails.vue?vue&type=template&id=68ba4620&scoped=true&"
import script from "./SkillDetails.vue?vue&type=script&lang=js&"
export * from "./SkillDetails.vue?vue&type=script&lang=js&"
import style0 from "./SkillDetails.vue?vue&type=style&index=0&id=68ba4620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba4620",
  null
  
)

export default component.exports